<template>
  <div
    v-if="books"
    class="page has-background-blue with-title"
  >
    <h1 class="page-title has-text-weight-bold has-text-centered is-size-5">
      {{ section_title }}
    </h1>
    <div class="container p-4">
      <div class="columns is-multiline is-mobile">
        <generic-mosaic-item
          v-for="item in books"
          :key="item.id"
          :data="item"
          @click="openContent(item)"
        />
        <div
          v-if="emptyResult"
          class="column is-12-mobile is-6-tablet is-offset-3-tablet"
        >
          <div class="no-results">
            No se han encontrado resultados.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GenericMosaicItem from "@/components/lists/GenericMosaicItem";

export default {
  name: 'MediaBookList',
  components: {GenericMosaicItem},
  title: 'Libros de interactivos',
  data: function () {
    return {
      section_title: 'Libros de interactivos',
      books: null
    }
  },
  computed: {
    emptyResult() {
      if (!this.books) {
        return false
      }

      return this.books.length === 0
    },
    userToken() {
      return this.$store.state.token
    }
  },
  watch: {
    userToken() {
      console.info("Cambio Token")
      console.info(this.userToken)
      this.loadContent()
    }
  },
  beforeMount() {
    this.loadContent()
  },
  methods: {
    async loadContent() {
      try {
        await this.$store.dispatch('initLoading')

        this.books = await this.$api.media.getBookList()

        await this.$store.dispatch('finishLoading')
      } catch (error) {
        await this.$store.dispatch('finishLoading')

        await this.handleContentError(error)
      }
    },
    openContent(item) {
      const bookId = item.id
      this.$router.push(`/media-books/${bookId}`)
    }
  }
}
</script>
